module.exports = __webpack_public_path__ + "static/blog-22-5006bf62ca4508859a5bac0683009402.png";